import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=3d80c36a&scoped=true&"
var script = {}
import style0 from "./explain.vue?vue&type=style&index=0&id=3d80c36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d80c36a",
  null
  
)

export default component.exports